import { http } from "../../common/helpers/http";
import { baseUrl } from "../../common/config";

export const subscriptionService = (data, landingPage) =>
  landingPage === "/subscription"
    ? http.post(`${baseUrl}/api/participant/create-subscription`, data)
    : http.post(`${baseUrl}/api/participant/renew-subscription`, data);

export const getCoupon = async (promotionCode, landingPage) => {
  const path =
    landingPage === "/enroll"
      ? `${baseUrl}/api/payment/coupon/without-organization-filter/${promotionCode}`
      : `${baseUrl}/api/payment/coupon/${promotionCode}`;
  try {
    const response = await http({
      url: path,
      method: "GET",
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const getOrganizationSettings = (idOrganization) => {
  return http.get(`${baseUrl}/api/organization/${idOrganization}/settings`);
};
